import type {
	GetCustomFactorResponseJSON,
	GetCustomFactorsResponseJSON,
	MutateCustomFactorResponseJSON,
} from "@performyard/service-contracts";

import request from "./internal-api/internal-base-request";

// Re-export shared types for convenience
export type { CustomFactor } from "@performyard/service-contracts";

// Input types (no ObjectIDs, same shape on frontend and backend)
export interface CustomFactorCreateInput {
	name: string;
	description?: string | null;
	include_in_overall_satisfaction?: boolean;
}

export interface CustomFactorUpdateInput {
	name?: string;
	description?: string | null;
	include_in_overall_satisfaction?: boolean;
}

// Re-export response types used by hooks
export type { GetCustomFactorsResponseJSON as GetCustomFactorsResponse } from "@performyard/service-contracts";
export type { GetCustomFactorResponseJSON as GetCustomFactorResponse } from "@performyard/service-contracts";
export type { MutateCustomFactorResponseJSON as MutateCustomFactorResponse } from "@performyard/service-contracts";

// API Functions
export const getEngagementCustomFactors = async (): Promise<GetCustomFactorsResponseJSON> => {
	const [response] = await request<GetCustomFactorsResponseJSON>("/v1/engagement/custom-factors", {
		method: "GET",
	});
	return response;
};

export const getEngagementCustomFactor = async (id: string): Promise<GetCustomFactorResponseJSON> => {
	const [response] = await request<GetCustomFactorResponseJSON>(`/v1/engagement/custom-factors/${id}`, {
		method: "GET",
	});
	return response;
};

export const createEngagementCustomFactor = async (
	factor: CustomFactorCreateInput
): Promise<MutateCustomFactorResponseJSON> => {
	const [response] = await request<MutateCustomFactorResponseJSON>("/v1/engagement/custom-factors", {
		method: "POST",
		body: JSON.stringify(factor),
	});
	return response;
};

export const updateEngagementCustomFactor = async (
	id: string,
	factor: CustomFactorUpdateInput
): Promise<MutateCustomFactorResponseJSON> => {
	const [response] = await request<MutateCustomFactorResponseJSON>(`/v1/engagement/custom-factors/${id}`, {
		method: "PATCH",
		body: JSON.stringify(factor),
	});
	return response;
};

export const deleteEngagementCustomFactor = async (id: string): Promise<void> => {
	await request<{ message: string }>(`/v1/engagement/custom-factors/${id}`, {
		method: "DELETE",
	});
};
